<template>
  <div id="app">
    <Spinner
      :visible="Boolean(requestsInProgress)" />
    <router-view/>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'

import Spinner from './components/Spinner'

export default {
  name: 'App',
  components: {
    Spinner
  },
  created() {
    // Check authentication status when the component is created
    this.checkAuthStatus()
      .catch(error => console.error('Error checking auth status:', error))
  },
  mounted () {
    this.startListener()
  },
  computed: {
    ...mapState([
      'requestsInProgress'
    ])
  },
  methods: {
    ...mapActions([
      'startListener',
      'checkAuthStatus',
      'loadMore'
    ])
  }
}
</script>

<style>
html {
  overflow-y: scroll;
}

html, body {
  background-color: #FAFAFA;
}

#app {
  font-family: sans-serif;
  color: #212121;
  display: grid;

  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
}

.header {
  padding-top: 30px;
}

.page {
  padding: 30px 0;

  display: grid;
  grid-template-columns: 200px 1fr;
  grid-column-gap: 30px;
}

.search-box {
  width: 100%;
  box-sizing: border-box;
  padding: 13px 15px;
  margin-bottom: 14px;
}

.container {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

</style>
